import Vue from 'vue'
import Vuex from 'vuex'
import ApiCaller from "../utils/apicaller"
import types from "./types"

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        maxSecondForcall: 0,
        timeDuration: 0,
        netOnOff: true,
        disconnection: 'false',
        userImg: "",
        callingScreenCompleteObj: null
    },
    mutations: {
        'MaxSecondForcall': (state, payload) => {
            state.maxSecondForcall = payload
        },
        'TimeDuration' : (state, payload) => {
            state.timeDuration = payload
        },
        'Internet': (state, payload) => {
            state.netOnOff = payload
        },
        'DisconnectingStatus': (state, payload) => {
            console.log('==payload=',payload)
            state.disconnection = payload
        },
        'UserImage': (state, payload) => {
            console.log('=',payload)
            state.userImg = payload
        },
        'callingScreenCompleteObj': (state, payload) => {
            console.log('=payload==', payload)
            state.callingScreenCompleteObj = payload
        }
    },
    actions: { 
        async getCallerHistory({ commit }, { type, payload }) {
            let getCallerHistory = await ApiCaller('/call_history', 'get')
            return getCallerHistory
        },
        async partnerLogin({ commit }, { type, payload }) {
            console.log('==payload==',payload)
            let partnerLogin = await ApiCaller('/receiver_login', 'post', payload)
            return partnerLogin
        },
        async removeWaitingUser({ commit }, { type, payload }) {
            console.log('==payload==',payload)
            let removeWaitingUser = await ApiCaller('/remove_waiting_user', 'put')
            return removeWaitingUser
        },
        async userDetail({ commit }, { type, payload }) {
            let userDetail = await ApiCaller('/user_details', 'get')
            return userDetail
        },
        
    }
});